import { render, staticRenderFns } from "./translation.vue?vue&type=template&id=85ba0cf4&scoped=true&"
import script from "./translation.vue?vue&type=script&lang=js&"
export * from "./translation.vue?vue&type=script&lang=js&"
import style0 from "./translation.vue?vue&type=style&index=0&id=85ba0cf4&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85ba0cf4",
  null
  
)

export default component.exports